module.exports = __webpack_public_path__ + "static/media/ios-planet.4fd21f9b.svg";